import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { kanekaPageMeta, kanekaSchema } from 'components/common/schema'
import Template from 'components/cases/kaneka'

const Kaneka: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...kanekaPageMeta} />
      <JsonLd data={kanekaSchema} />
      <Template />
    </>
  )
}

export default Kaneka
